import React from 'react';
import {Segment, Grid, Card, Header} from 'semantic-ui-react';
import './Clock.css';

export default (props) => {
    return (
        <div className="clock-container">
            <Segment basic className="time-left-container">
                <Header style={{fontWeight: 100}}>
                    {props.lang.time_left_label}
                </Header>
            </Segment>
            <Grid>
                <Grid.Row stretched columns={4} style={{padding: "0.5rem"}}>
                    <Grid.Column style={{padding: "0.5rem"}}>
                        <Card>
                            <Card.Content className="clock-value-container">
                                {props.days}
                            </Card.Content>
                            <Card.Content style={{background: "#E21F14"}} extra>
                                <Header className="clock-value-header">
                                    {props.lang.days_label}
                                </Header>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column style={{padding: "0.5rem"}}>
                        <Card>
                            <Card.Content className="clock-value-container">
                                {props.hours}
                            </Card.Content>
                            <Card.Content style={{background: "#E21F14"}} extra>
                                <Header className="clock-value-header">
                                    {props.lang.hours_label}
                                </Header>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column style={{padding: "0.5rem"}}>
                        <Card>
                            <Card.Content className="clock-value-container">
                                {props.minutes}
                            </Card.Content>
                            <Card.Content style={{background: "#E21F14"}} extra>
                                <Header className="clock-value-header">
                                    {props.lang.minutes_label}
                                </Header>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                    <Grid.Column style={{padding: "0.5rem"}}>
                        <Card>
                            <Card.Content className="clock-value-container">
                                {props.seconds}
                            </Card.Content>
                            <Card.Content style={{background: "#E21F14"}} extra>
                                <Header className="clock-value-header">
                                    {props.lang.seconds_label}
                                </Header>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/clock/ClockContainer.jsx